import { useState } from "react";
import { Column, Row, Spacer } from "../../../../components/Layout/Layout";
import useTranslations from "../../../../core/i18n/useTranslations";
import { AlarmCodeRuleTable } from "./AlarmCodeRuleTable";
import CreateAlarmCodeRuleModal from "./CreateAlarmCodeRuleModal";
import EditAlarmCodeRuleModal from "./EditAlarmCodeRuleModal";

export const AlarmCodeRules = ({
  responseCenterId,
}: {
  responseCenterId: string | number;
}) => {
  const t = useTranslations();

  const [reloadTableFlag, setReloadTableFlag] = useState(false);
  const [upForEdit, setUpForEdit] = useState<number | undefined>();

  const requestRefetch = () => {
    setReloadTableFlag(!reloadTableFlag);
  };

  return (
    <Column className="w-100" type="top" align="start">
      <h1>{t("AlarmReceptions:alarm_handling_alarm_code_rules")}</h1>
      <Spacer size={8} />
      <p className="grey-600">
        {t("AlarmReceptions:alarm_code_rules_description")}
      </p>
      <Spacer size={16} />
      <Row className="w-100 flex0" type="space">
        <h2>{t("AlarmReceptions:code_rules_list")}</h2>
        <Spacer />
        <CreateAlarmCodeRuleModal
          responseCenterId={responseCenterId}
          onAdd={requestRefetch}
        />
      </Row>
      <Spacer size={32} />
      <AlarmCodeRuleTable
        responseCenterId={responseCenterId}
        onStartEdit={(rowData) => {
          setUpForEdit(rowData.id);
        }}
        fetchFlag={reloadTableFlag}
      />

      {upForEdit && (
        <EditAlarmCodeRuleModal
          responseCenterId={responseCenterId}
          alarmCodeRuleId={upForEdit}
          onEdit={requestRefetch}
          closeModal={() => setUpForEdit(undefined)}
        />
      )}
    </Column>
  );
};
